module.exports = __webpack_public_path__ + "media/newstyle/images/icon-logo-blog-white-d263749eee7e15ffe8b5c52d91f0d31a.svg";